/**
 * The set of allowed navigation colors.
 */
export enum NavColors {
  turquoise = "turquoise",
  darkblue = "darkblue",
  green = "green",
  darkgreen = "darkgreen",
  purple = "purple",
  yellow = "yellow",
  orange = "orange",
  red = "red",
}

/**
 * The set of available navigation colors.
 */
export type NavColor = keyof typeof NavColors;
